<template>
  <el-dialog :visible.sync="pwdShow" width="500px" class="dialog-pwd" :class="{ 'dialog-set-pwd': pwdShow }"
    :center="true" :close-on-click-modal="false" :append-to-body="true" @close="closeDialog">
    <div v-if="pwdShow" class="pwd-content">
      <div class="close-btn" @click="passwordClose"> <i class="el-icon-close"></i></div>
      <!-- 设置密码 -->
      <template v-if="dialogType === 'setPwd'">
        <div class="center-title">{{ $t("setPayPwd") }}</div>
        <div class="password-content">
          <p class="num-tips">{{ $t('numInputTips') }}</p>
          <div class="small-title">{{ $t("setPwdTits") }}</div>
          <PasswordInput @setPwdVal="setPasswordValue"></PasswordInput>
          <div class="small-title">{{ $t("setPayPwdAgain") }}</div>
          <PasswordInput @setPwdVal="setConPasswordValue"></PasswordInput>
        </div>
      </template>
      <!-- 修改密码 -->
      <template v-else-if="dialogType === 'changePwd'">
        <div class="center-title">{{ $t("changePassword") }}</div>
        <div class="password-content">
          <p class="num-tips">{{ $t('numInputTips') }}</p>
          <div class="small-title">{{ $t("inputPwdToSign") }}</div>
          <PasswordInput @setPwdVal="setOldPasswordValue"></PasswordInput>
          <div class="small-title">{{ $t("setPwdTits") }}</div>
          <PasswordInput @setPwdVal="setPasswordValue"></PasswordInput>
          <div class="small-title">{{ $t("setPayPwdAgain") }}</div>
          <PasswordInput @setPwdVal="setConPasswordValue"></PasswordInput>
        </div>
      </template>
      <!-- 找回密码 -->
      <template v-else-if="dialogType === 'forgetPwd'">
        <div class="center-title">{{ $t("setPayPwd") }}</div>
        <div class="password-content">
          <p class="num-tips">{{ $t('numInputTips') }}</p>
          <div class="small-title">{{ $t("setPwdTits") }}</div>
          <PasswordInput @setPwdVal="setPasswordValue"></PasswordInput>
          <div class="small-title">{{ $t("setPayPwdAgain") }}</div>
          <PasswordInput @setPwdVal="setConPasswordValue"></PasswordInput>
          <div class="small-title">{{ $t("emailToReset") }}</div>
          <div class="code-content">
            <el-input v-model="emailCode"></el-input>
            <el-button @click="sendHandle" :disabled="disabled">{{
              sendCode
              }}</el-button>
          </div>
        </div>
      </template>
      <!-- 设置安全邮箱 -->
      <template v-else-if="dialogType === 'setEmail'">
        <div class="center-title">{{ $t("emailToPwd") }}</div>
        <div class="password-content">
          <div class="small-title">{{ $t("inputBindEmail") }}</div>
          <div class="code-content">
            <el-input v-model="email"></el-input>
          </div>
          <div class="small-title">{{ $t("inputCode") }}</div>
          <div class="code-content">
            <el-input v-model="emailCode"></el-input>
            <el-button @click="sendHandle" :disabled="disabled">{{
              sendCode
              }}</el-button>
          </div>
        </div>
      </template>
      <!-- 查看安全邮箱 -->
      <template v-else-if="dialogType === 'showEmail'">
        <div class="center-title">{{ $t("boundEmail") }}</div>
        <div class="password-content">
          <!-- <div class="small-title">{{ $t("inputBindEmail") }}</div> -->
          <p>{{ email }}</p>
        </div>
      </template>
      <!-- 支付密码 -->
      <template v-else>
        <div class="title">{{ $t("inputPayPwd") }}</div>
        <div class="password-content">
          <PasswordInput @setPwdVal="setPasswordValue"></PasswordInput>
        </div>
      </template>

      <div class="btn-list">
        <el-button @click="setPwdStatus">{{ $t("sure") }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PasswordInput from "./PasswordInput.vue";
import { mapActions, mapGetters } from "vuex";
import eventBus from '../utils/eventBus'
import qs from "qs";
export default {
  name: "",
  components: { PasswordInput },
  data() {
    return {
      storage: {},
      ruleSwitch: {},
      pwdPay: false,
      pwdShow: false,
      selfPassword: [],

      contentHeight: "250px",
      dialogType: "",
      payPwd: "", //支付密码
      conPwd: "", //支付确认密码
      oldPwd: "", //之前支付密码
      emailCode: "", //code
      disabled: false,
      isDisabled: false,
      email: "", //邮箱
      timer: null,
      sendCode: this.$t("sendCode"),
    };
  },
  computed: {
    ...mapGetters([
      "uwLoading",
      "pointSwitch",
      "pointData",
      "pointRule",
      "pwdFlag",
      "pointInit",
      "psStatus", //设置密码状态
      "pwdData",
      "emailFlag",

      "codeStatus", //验证码状态
      "codeData",
      "seStatus", //设置安全邮箱状态
      "setEmailData",
      "peStatus",
      "peData",
      "checkStatus",
      "checkData",
      "cpeLoading",
      "cpeData",
      "cpStatus",
      "cPwdData",
    ]),
  },
  mounted() {  
    eventBus.$on('showPwdOrEmailDialog', (type,date) => {
      this.showDialog(type,date)
    })
    this.initData();
  },
  watch: {
    // 修改密码成功
    cpStatus(val) {
      if (val == "stated") {
        if (this.cPwdData == "success") {
          this.pwdShow = false;

          if (!this.emailFlag.isEmailSet) {
            this.$confirm(this.$t("toSetEmailTits"), this.$t("payTits"), {
              confirmButtonText: this.$t("toSetEmail"),
              cancelButtonText: this.$t("backToStore"),
              customClass: "email-pwd-message-box",
            })
              .then(() => {
                this.showDialog("setEmail");
              })
              .catch(() => {
                this.pwdShow = false;
                this.initData();
              });
          } else {
            this.initData();
          }
        }
      }
    },
    pwdShow() {
      if (!this.pwdShow && this.timer) {
        clearTimeout(this.timer);
      }
      // if(!this.pwdShow){
      //   this.initData()
      // }
    },
    peStatus(val) {
      if (val == "stated") {
        if (this.dialogType == "showEmail") {
          this.email = this.peData.payEmail;
        }
      }
    },
    // 礼金相关
    uwLoading(val) {
      if (val === "loaded") {
        if (typeof this.pointSwitch !== "string") {
          this.ruleSwitch = this.pointSwitch.ruleSwitch;
          this.$emit("setRuleSwitch", this.ruleSwitch);
          let { accessToken, appId, language } = this.storage;
          // 获取用户礼金数据(允许显示礼金数量  礼金支付开关)
          if (this.ruleSwitch.quantityDisplay) {
            this.getUserPointData({
              accessToken: accessToken,
            });
            this.getUserPointRule({
              accessToken: accessToken,
              appId: CONFIG.appId,
              language: window.localStorage.getItem('language'),
            });
            this.pwdPay = true;
            // 第一次付款
            this.getPointInit({
              accessToken: accessToken,
              appId: CONFIG.appId,
            });
          } else {
            this.pwdPay = false;
          }
        }
      
      }
    },
    // 设置密码
    psStatus(val) {
      if (val == "stated") {
        if (this.pwdData == "success") {
          //没有设置邮箱
          if (!this.emailFlag.isEmailSet) {
            this.$confirm(this.$t("toSetEmailTits"), this.$t("payTits"), {
              confirmButtonText: this.$t("toSetEmail"),
              cancelButtonText: this.$t("backToStore"), 
              customClass: "email-pwd-message-box",
            })
              .then(() => {
                this.showDialog("setEmail");
              })
              .catch(() => {
                this.pwdShow = false;
                this.initData();
              });
          } else {
            this.pwdShow = false;
            this.initData();
          }
        }
      }
    },
    // 验证码状态
    codeStatus(val) {
      if (val === "stated") {
        if (this.codeData == "success") {
          this.$message.success(this.$t("sended"));
          this.disabled = true;
          let count = 30;
          this.timer = setInterval(() => {
            if (count === 0) {
              this.disabled = false;
              this.sendCode = this.$t("sendCode");
              clearInterval(this.timer);
            } else {
              count--;
              this.sendCode = count + this.$t("retry");
            }
          }, 1000);
        }
      }
    },
    // 设置邮箱
    seStatus(val) {
      if (val === "stated") {
        if (this.setEmailData === "success") {
          this.showDialog("showEmail", this.email);
          this.pwdShow = false;
          this.initData();
        }
      }
    },
    // 三方商城修改密码时校验支付旧密码
    checkStatus(val) {
      if (val === "stated") {
        if (typeof this.checkData !== "string") {
          if (this.checkData.hasRightOldPassword.checkStatus) {
            // 旧密码验证成功
            if (this.conPwd != this.payPwd) {
              this.$message.error(this.$t("pwdDontmatch"));
            } else if (!/^\d+$/.test(this.payPwd)) {
              this.$message.error(this.$t("numInputComTips"));
            }
            else {
              if (this.payPwd.length > 5) {
                this.changePayPwd({
                  type: 2,
                  accessToken: this.storage.accessToken,
                  appId: CONFIG.appId,
                  newPassword: this.$md5(this.payPwd),
                  oldPassword: this.$md5(this.oldPwd),
                  isUseLogin: 0,
                });
              }
            }
          } else {
            if (this.checkData.hasRightOldPassword.attemptNumber < 5) {
              this.$message.error(
                this.$t("pwdErrorTimes", {
                  msg: 5 - this.checkData.hasRightOldPassword.attemptNumber,
                })
              );
              // 清空old密码
            } else {
              this.$message.error(this.$t("pwdErrorMax"));
              // 清空old密码
            }
          }
        }
      }
    },
    // 忘记密码
    cpeLoading(val) {
      if (val === "loaded") {
        if (typeof this.cpeData !== "string") {
          if (this.cpeData.hasRightEmailCode.checkStatus) {
            if (this.conPwd != this.payPwd) {
              this.$message.error(this.$t("pwdDontmatch"));
            } else {
              if (this.payPwd.length > 5) {
                if (!/^\d+$/.test(this.payPwd)) {
                  this.$message.error(this.$t("numInputComTips"));
                } else {
                  this.changePayPwd({
                    type: 1,
                    accessToken: this.storage.accessToken,
                    appId: CONFIG.appId,
                    newPassword: this.$md5(this.payPwd),
                    emailCode: this.emailCode,
                    isUseLogin: 0,
                  });
                }

              }
            }
          } else {
            if (this.cpeData.hasRightEmailCode.attemptNumber < 5) {
              this.$message.error(
                this.$t("emailErrorTimes", {
                  msg: 5 - this.cpeData.hasRightEmailCode.attemptNumber,
                })
              );
            } else {
              this.$message.error(this.$t("emailErrorMax"));
            }
          }
        }
      }
    },
  },
  methods: {
    ...mapActions([
      "getUserPointSwitch",
      "getUserPointData",
      "getUserPointRule",
      "getPointInit",

      "getPayPwdFlag",

      "setPayPwd",
      "getEmailFlag",
      "changePayPwd",
      "getEmailCode",
      "checkPayEmail",
      "setPayEmail",
      "getUserPayEmail",
      "checkPayPwd",
    ]),
    closeDialog(){
      this.$emit("closeDialog");
    },
    initData() {
      this.storage = JSON.parse(window.localStorage.getItem("storage"));
      // PC 查询所有币种和符号的映射关系
      let { accessToken, appId, language } = this.storage;

      // 礼金开关
      this.getUserPointSwitch({
        accessToken: accessToken,
        appId: CONFIG.appId,
        language: window.localStorage.getItem('language'),
      });
      // 获取邮箱验证状态
      this.getEmailFlag({
        accessToken: accessToken,
        appId: CONFIG.appId,
      });
      // 获取支付密码开关
      this.getPayPwdFlag({
        accessToken: accessToken,
        appId: CONFIG.appId,
      });
    },
    showDialog(status, data = {}) {
      this.dialogType = status || "";
      this.payPwd = ""; //支付密码
      this.conPwd = ""; //支付确认密码
      this.oldPwd = ""; //之前支付密码
      this.emailCode = ""; //code
      this.disabled = false;
      this.email = data.email || ""; //邮箱
      this.pwdShow = true;
      this.isDisabled = false;
      this.sendCode = this.$t("sendCode");
      if (this.timer) {
        clearTimeout(this.timer);
      }
      // 查看邮箱
      if (this.dialogType == "showEmail") {
        if (!this.email) {
          this.getUserPayEmail({
            accessToken: this.storage.accessToken,
            appId: CONFIG.appId,
          });
        }
      }
    },
    passwordClose() {
      this.pwdShow = false;
      this.initData();
    },
    setPasswordValue(val) {
      this.payPwd = val;
    },
    setOldPasswordValue(val) {
      this.oldPwd = val;
    },
    setConPasswordValue(val) {
      this.conPwd = val;
    },
    // 获取验证m
    sendHandle() {
      if (this.dialogType == "forgetPwd") {
        this.getEmailCode({
          emailType: 2,
          language: window.localStorage.getItem('language'),
          accessToken: this.storage.accessToken,
          appId: CONFIG.appId,
        });
        return;
      }
      if (
        /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(
          this.email
        )
      ) {
        this.$confirm(this.$t("emailDialog"), this.$t("sureAgain"), {
          confirmButtonText: this.$t("sure"),
          cancelButtonText: this.$t("cancel"),
          className: "emailDialog email-pwd-message-box",
        }).then(() => {
          this.getEmailCode({
            emailType: 1,
            language: window.localStorage.getItem('language'),
            accessToken: this.storage.accessToken,
            appId: CONFIG.appId,
            targetEmail: this.email,
          });
        });
      } else if (!this.email) {
        this.$message.error(this.$t("noEmail"));
      } else {
        this.$message.error(this.$t("emailPatternErr"));
      }
    },
    setPwdStatus() {
      switch (this.dialogType) {
        case "setPwd": //设置密码
          if (this.payPwd && this.payPwd.length > 5) {
            if (this.conPwd != this.payPwd) {
              this.$message.error(this.$t("pwdDontmatch"));
            } else if (!/^\d+$/.test(this.payPwd)) {
              this.$message.error(this.$t("numInputComTips"));
            } else {
              this.setPayPwd(
                qs.stringify({
                  accessToken: this.storage.accessToken,
                  appId: CONFIG.appId,
                  newPassword: this.$md5(this.payPwd),
                  isUseLogin: 0,
                })
              );
            }
          }
          break;
        case "changePwd": //修改密码
          if (this.oldPwd && this.oldPwd.length > 5) {
            if (!/^\d+$/.test(this.oldPwd)) {
              this.$message.error(this.$t("numInputComTips"));
            } else {
              this.checkPayPwd({
                accessToken: this.storage.accessToken,
                appId: CONFIG.appId,
                oldPassword: this.$md5(this.oldPwd),
              });
            }

          }
          break;
        case "forgetPwd": //忘记密码
          if (this.emailCode) {
            this.checkPayEmail({
              accessToken: this.storage.accessToken,
              appId: CONFIG.appId,
              language: window.localStorage.getItem('language'),
              emailCode: this.emailCode,
            });
          }

          break;

        case "setEmail": //设置邮箱
          if (!this.email) {
            this.$message.error(this.$t("noEmail"));
          } else if (
            !/^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(
              this.email
            )
          ) {
            this.$message.error(this.$t("emailPatternErr"));
          } else if (!this.emailCode) {
            this.$message.error(this.$t("inputCode"));
          } else {
            this.setPayEmail(
              qs.stringify({
                accessToken: this.storage.accessToken,
                appId: CONFIG.appId,
                language: window.localStorage.getItem('language'),

                email: this.email,
                verifyCode: this.emailCode,
              })
            );
          }
          break;
        case "showEmail": //查看邮箱
          this.pwdShow = false;
          break;
          // 输入了 支付密码 去支付
        default:
          if (!/^\d+$/.test(this.payPwd)) {
            this.$message.error(this.$t("numInputTips"));
          } else {
            // this.$emit("toPayByPassword", this.payPwd);
            eventBus.$emit(
              "toPayByPassword",
              this.payPwd,
            );
            this.pwdShow = false;
          }
          break;
      }
    },
  },
  beforeDestroy() {
    eventBus.$off('showPwdOrEmailDialog'); // 必须取消订阅
  },
};
</script>
<style lang="scss">
.email-pwd-message-box {
  .el-button--small {
    border-radius: 30px;
    font-size: 18px !important;
    border: 1px solid #d32e26 !important;
  }

  .el-button--primary {
    border: none;
    cursor: pointer;
    color: #fff !important;
    font-size: 18px !important;
    background-color: #d32e26;
    border-radius: 30px;

    &.is-disabled {
      background-color: #fab6b6;
      border-color: #fab6b6;
      cursor: not-allowed;
    }
  }

}

.dialog-pwd {
  .el-dialog__header {
    display: none;
  }

  .close-btn {
    // background: url("../assets/close.png") 0 100% no-repeat;
    background-size: 100% auto !important;
    width: 24px;
    height: 24px;
    font-size: 20px;
    position: absolute;
    cursor: pointer;
    right: 10px;
    top: 12px;
  }

  .el-dialog__body {
    padding: 0;

    .btn-list {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      button {
        width: 80px;
        margin-left: 8px;
        border: none;
        cursor: pointer;
        color: #fff;
        background-color: #d32e26;
        border-radius: 30px;

        &.is-disabled {
          background-color: #fab6b6;
          border-color: #fab6b6;
          cursor: not-allowed;
        }
      }
    }

    .title {
      // color: #f0d386;
      font-size: 18px;
      margin: 10px 0 10px;
    }

    .center-title {
      text-align: center;
      font-size: 20px;
      // color: white;
      margin-top: 10px;
    }

    .password-content {
      padding: 20px 0 20px;

      .small-title {
        // color: #f0d386;
        font-size: 14px;
        margin-top: 14px;
        margin-bottom: 0;
      }

      p {
        padding: 0;
        margin: 6px 0;
      }

      .num-tips {
        font-size: 14px;
        text-align: center;
        margin-top: -16px;
      }
    }
  }

  .pwd-content {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    // background: url("../assets/dialog.png") center no-repeat;
    box-sizing: border-box;
    height: auto;
    background-size: 100% 100%;
  }

  p {
    font-size: 24px;
    // color: white;
  }

  .code-content {
    display: flex;
    align-items: center;
    width: 80%;

    button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      background-color: #d32e26;
      // background: linear-gradient(0deg, #f0d386, #906e10);
      height: 40px;
      // border: 1px solid #473420;
      border: none;
      color: #fff;
    }

    .el-input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      min-width: 110px;

      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        // background-color: rgba(0, 0, 0, 0.2);
        // border: 1px solid #473420;
        // color: white;
      }
    }
  }

}

.el-message-box .el-message-box__btns .el-button {
  width: auto;
  min-width: 200px;
}

.el-message-box__btns .el-button {
  width: auto;
}
</style>
